import Page from './index';
import { authRoles } from 'app/auth';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	auth: authRoles.adminAgent,
	routes: [
		{
			path: '/agent-management',
			exact: true,
			component: Page.Layout
		},
		// {
		// 	path: '/agent-management/:id',
		// 	exact: true,
		// 	component: Page.Details
		// },
		{
			path: '/template',
			exact: true,
			component: Page.TemplateLayout
		},
	]
};